import Layer from './Layer';

const MORIOKA_LAYERS = {
    // 盛岡防災マップ レイヤー構成

    // 警戒区域
    // 現象種別コード（A33_001）と区域区分コード（A33_002）を組み合わせた区域。
    'warning_area_6-fillpattern': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '6', type: 'fill' },   // 地すべり（土砂災害特別警戒区域）
    'warning_area_5-fillpattern': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '5', type: 'fill' },   // 土石流（土砂災害特別警戒区域）
    'warning_area_3-fillpattern': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '3', type: 'fill' },   // 地すべり（土砂災害警戒区域）
    'warning_area_2-fillpattern': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '2', type: 'fill' },   // 土石流（土砂災害警戒区域）
    'warning_area_6-line': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '6', type: 'line' },   // 地すべり（土砂災害特別警戒区域）
    'warning_area_5-line': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '5', type: 'line' },   // 土石流（土砂災害特別警戒区域）
    'warning_area_4-line': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '4', type: 'line' },   // 急傾斜地の崩壊（土砂災害特別警戒区域）
    'warning_area_3-line': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '3', type: 'line' },   // 地すべり（土砂災害警戒区域）
    'warning_area_2-line': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '2', type: 'line' },   // 土石流（土砂災害警戒区域）
    'warning_area_1-line': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '1', type: 'line' },   // 急傾斜地の崩壊（土砂災害警戒区域）
    'warning_area_6-fill': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '6', type: 'fill', isClickable: true },   // 地すべり（土砂災害特別警戒区域）
    'warning_area_5-fill': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '5', type: 'fill', isClickable: true },   // 土石流（土砂災害特別警戒区域）
    'warning_area_4-fill': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '4', type: 'fill', isClickable: true },   // 急傾斜地の崩壊（土砂災害特別警戒区域）
    'warning_area_3-fill': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '3', type: 'fill', isClickable: true },   // 地すべり（土砂災害警戒区域）
    'warning_area_2-fill': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '2', type: 'fill', isClickable: true },   // 土石流（土砂災害警戒区域）
    'warning_area_1-fill': { 'source-layer': 'sediment-disaster-warning-area', property: 'warning_area_code', code: '1', type: 'fill', isClickable: true },   // 急傾斜地の崩壊（土砂災害警戒区域）

    // 危険箇所
    // 危険箇所種別コード（A26_001）の一部区域。
    'hazard_area_7-fillpattern': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '7', type: 'fill' }, // 地すべり危険箇所
    'hazard_area_2-fillpattern': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '2', type: 'fill' }, // 土石流危険区域
    'hazard_area_7-line': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '7', type: 'line' }, // 地すべり危険箇所
    'hazard_area_5-line': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '5', type: 'line' }, // 急傾斜地崩壊危険箇所
    'hazard_area_2-line': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '2', type: 'line' }, // 土石流危険区域
    'hazard_area_7-fill': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '7', type: 'fill', isClickable: true }, // 地すべり危険箇所
    'hazard_area_5-fill': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '5', type: 'fill', isClickable: true }, // 急傾斜地崩壊危険箇所
    'hazard_area_2-fill': { 'source-layer': 'sediment-disaster-hazard-area', property: 'hazard_area_code', code: '2', type: 'fill', isClickable: true }, // 土石流危険区域
};

const DEFAULT_OPACITY = 0.75;

// 線幅はズームしていくにつれ太くする。
const LINE_WIDTH = [
    'interpolate',
    ['linear'],
    ['zoom'],
    11, 0.1,
    12, 0.5,
    13, 1.0,
    14, 2.0,
];

// ハザードマップ
export default class SedimentDisasterHazardMap extends Layer {
    url = process.env.REACT_APP_SEDIMENTDISASTERHAZARDMAP_URL;
    popup = null;

    constructor() {
        const id = 'sediment-disaster-hazard-map';

        const layers = {};
        for (const key in MORIOKA_LAYERS) {
            const layer = MORIOKA_LAYERS[key];
            layers[key] = {
                type: layer.type,
                source: id,
                'source-layer': layer['source-layer'],
                filter: ["==", layer.property, layer.code],
                minzoom: 8
            };
        }

        const paintOptions = {
            'warning_area_1-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#F3D555', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 急傾斜地の崩壊（土砂災害警戒区域）
            'warning_area_2-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#F3D555', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 土石流（土砂災害警戒区域）
            'warning_area_3-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#F3D555', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 地すべり（土砂災害警戒区域）
            'warning_area_4-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#E55867', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 急傾斜地の崩壊（土砂災害特別警戒区域）
            'warning_area_5-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#E55867', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 土石流（土砂災害特別警戒区域）
            'warning_area_6-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#E55867', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 地すべり（土砂災害特別警戒区域）
            'warning_area_1-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, },   // 急傾斜地の崩壊（土砂災害警戒区域）
            'warning_area_2-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, },   // 土石流（土砂災害警戒区域）
            'warning_area_3-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, },   // 地すべり（土砂災害警戒区域）
            'warning_area_4-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, },   // 急傾斜地の崩壊（土砂災害特別警戒区域）
            'warning_area_5-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, },   // 土石流（土砂災害特別警戒区域）
            'warning_area_6-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, },   // 地すべり（土砂災害特別警戒区域）
            'warning_area_2-fillpattern': { 'fill-opacity': DEFAULT_OPACITY, 'fill-pattern': 'percent-10', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 土石流（土砂災害警戒区域）
            'warning_area_3-fillpattern': { 'fill-opacity': DEFAULT_OPACITY, 'fill-pattern': 'large-grid', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 地すべり（土砂災害警戒区域）
            'warning_area_5-fillpattern': { 'fill-opacity': DEFAULT_OPACITY, 'fill-pattern': 'percent-10', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 土石流（土砂災害特別警戒区域）
            'warning_area_6-fillpattern': { 'fill-opacity': DEFAULT_OPACITY, 'fill-pattern': 'large-grid', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 地すべり（土砂災害特別警戒区域）
            'hazard_area_2-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#F3D555', 'fill-outline-color': 'rgba(0, 0, 0, 0)' }, // 土石流危険区域
            'hazard_area_5-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#F3D555', 'fill-outline-color': 'rgba(0, 0, 0, 0)' }, // 急傾斜地崩壊危険箇所
            'hazard_area_7-fill': { 'fill-opacity': DEFAULT_OPACITY, 'fill-color': '#F3D555', 'fill-outline-color': 'rgba(0, 0, 0, 0)' }, // 地すべり危険箇所
            'hazard_area_2-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, 'line-dasharray': [4, 4], }, // 土石流危険区域
            'hazard_area_5-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, 'line-dasharray': [4, 4], }, // 急傾斜地崩壊危険箇所
            'hazard_area_7-line': { 'line-color': '#606060', 'line-width': LINE_WIDTH, 'line-dasharray': [4, 4], }, // 地すべり危険箇所
            'hazard_area_2-fillpattern': { 'fill-opacity': DEFAULT_OPACITY, 'fill-pattern': 'percent-10', 'fill-outline-color': 'rgba(0, 0, 0, 0)' }, // 土石流危険区域
            'hazard_area_7-fillpattern': { 'fill-opacity': DEFAULT_OPACITY, 'fill-pattern': 'large-grid', 'fill-outline-color': 'rgba(0, 0, 0, 0)' },   // 地すべり危険箇所
        };

        // レイヤー要素。この単位でレイヤリングする。配列順に最前面→再後面
        const elements = [
            { id: 'warning_area_1_and_4', layers: ['warning_area_4-line', 'warning_area_4-fill', 'warning_area_1-line', 'warning_area_1-fill'], isShow: true },   // 急傾斜地の崩壊 警戒区域
            { id: 'warning_area_2_and_5', layers: ['warning_area_5-fillpattern', 'warning_area_2-fillpattern', 'warning_area_5-line', 'warning_area_5-fill', 'warning_area_2-line', 'warning_area_2-fill',], isShow: true },   // 土石流 警戒区域
            { id: 'warning_area_3_and_6', layers: ['warning_area_6-fillpattern', 'warning_area_3-fillpattern', 'warning_area_6-line', 'warning_area_6-fill', 'warning_area_3-line', 'warning_area_3-fill',], isShow: true },   // 地すべり 警戒区域
            { id: 'hazard_area_2', layers: ['hazard_area_2-fillpattern', 'hazard_area_2-line', 'hazard_area_2-fill'], isShow: true }, // 土石流危険区域
            { id: 'hazard_area_5', layers: ['hazard_area_5-line', 'hazard_area_5-fill'], isShow: true }, // 急傾斜地崩壊危険箇所
            { id: 'hazard_area_7', layers: ['hazard_area_7-fillpattern', 'hazard_area_7-line', 'hazard_area_7-fill'], isShow: true }, // 地すべり危険箇所
        ];

        super(id, layers, paintOptions, elements);
    }

    // レイヤーは時刻を持たないのでオーバーライドして null 値をセットする。
    set datetime(datetime) { super.datetime = null; }
    get datetime() { return super.datetime; }

    onClick(e) {
        const layers = [...Object.keys(MORIOKA_LAYERS).filter(x => MORIOKA_LAYERS[x].isClickable)];
        const features = this.map.queryRenderedFeatures(e.point, {
            layers: layers,
        });

        if (!features.length) {
            return;
        }

        const content = features.map(x => {
            const warning = x.properties.warning_area_name ? x.properties.warning_area_name : '';
            const hazard = x.properties.hazard_area_name ? x.properties.hazard_area_name : '';
            return warning + hazard;
        });

        return '土砂災害ハザードマップ<ul>' + content.map(x => `<li>${x}</li>`).join('') + '</ul>';
    }

    async add() {
        this.map.addSource(this.id, {
            type: "vector",
            minzoom: 0,
            maxzoom: 13,
            tiles: [this.url],
            attribution:
                '「岩手県土砂災害警戒区域等GISデータ」を加工して作成 | <a href="https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A26.html" target="_blank">「国土数値情報（土砂災害危険箇所データ）」を加工して作成</a>',
        });

        this._elements
            .forEach(element => {
                element.layers.forEach(id => {
                    this.map.addLayer({
                        id: id
                        , ...this.layers[id]
                        , layout: { visibility: (element.isShow ? 'visible' : 'none') }
                        , paint: { ...this._paintOptions[id] }
                    });
                });
            });
    }

    remove() {
        Object.keys(this.layers)
            .map(x => this.map.removeLayer(x));

        this.map.removeSource(this.id);
    }

    showElement(element, isShow) {
        this._elements
            .filter(x => (x.id === element))
            .forEach(x => {
                x.layers.forEach(id =>
                    this.map.setLayoutProperty(id, 'visibility', isShow ? 'visible' : 'none')
                );
                x.isShow = isShow;
            });
    }
};


